import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';

const VideoStructuredData = ({ videos, productLabel }) => {
  const string = JSON.stringify({
    '@context': 'https://schema.org',
    '@graph': videos.map(({ thumbnail, videoStill, shortDescription, url }) => ({
      '@type': 'VideoObject',
      name: productLabel,
      description: shortDescription,
      thumbnailUrl: [thumbnail || videoStill],
      contentUrl: url,
    }))
  });
  return (
    <Helmet>
      <script type="application/ld+json">{string}</script>
    </Helmet>
  );
};

VideoStructuredData.propTypes = {
  videos: PropTypes.arrayOf(PropTypes.shape({
    thumbnail: PropTypes.string,
    videoStill: PropTypes.string,
    shortDescription: PropTypes.string,
    url: PropTypes.string,
  })).isRequired,
  productLabel: PropTypes.string.isRequired,
};

export { VideoStructuredData };
